import { useErrorId } from '@lokalise/louis';
import type { InputHTMLAttributes } from 'react';
import React, { forwardRef } from 'react';

import { Error2 } from '../components';
import DisabledCheckbox from './components/DisabledCheckbox';
import ErrorCheckbox from './components/ErrorCheckbox';
import { CheckboxDefault, Container, Input, Label, Text } from './styles';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    /**
     * Renders a form validation `InputErrorMessage`.
     * */
    error?: boolean | string | string[];
}

const Checkbox2 = forwardRef<HTMLInputElement, CheckboxProps>(
    ({ children, checked, disabled, error, ...rest }, ref) => {
        const errorId = useErrorId();

        return (
            <Container>
                <Label>
                    <Input
                        {...rest}
                        ref={ref}
                        type="checkbox"
                        checked={checked}
                        aria-checked={checked}
                        disabled={disabled}
                        aria-invalid={!!error}
                        aria-errormessage={errorId}
                    />
                    {(() => {
                        if (disabled) {
                            return <DisabledCheckbox checked={checked} />;
                        }
                        if (error) {
                            return <ErrorCheckbox checked={checked} />;
                        }

                        return <CheckboxDefault checked={checked} />;
                    })()}
                    {children && <Text>{children}</Text>}
                </Label>
                {!!error && typeof error !== 'boolean' && <Error2 id={errorId}>{error}</Error2>}
            </Container>
        );
    },
);

Checkbox2.displayName = 'Checkbox';

export default Checkbox2;
